import jsPDF from "jspdf";
import { backendGetRequest } from "./callBackend";
import LogoArpariNavy from "../style/frontpage/img/arpari-logos/Logo-Arpari-navy.png";

async function generateAchDetailsPdf({
  beneficiaryName,
  beneficiaryAddress,
  accountNumber,
  routingNumber,
  accountType,
  bankName,
  bankAddress,
  bankAccountId
}) {
  if (routingNumber === "" || accountNumber === "") {
    try {
      const res = await backendGetRequest(
        "/api/bank-account/detokenize/",
        { params: { bank_account_id: bankAccountId } },
        "",
      );
      routingNumber = res?.data?.routing_number;
      accountNumber = res?.data?.account_number;
    } catch (err) {
      console.error('Error: ', err);
    }
  }

  const doc = new jsPDF("portrait", "pt", "A4")

  let pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
  let pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

  const marginPageLeft = 30;
  const marginColumn1Left = 50;
  const marginColumn2Left = 180;
  const marginPageRight = pageWidth - marginPageLeft;
  
  const rowTop = 50;
  const rowBottom = pageHeight - rowTop; 
  const sectionRowDelta = 60;
  const intrasectionRowDelta = 30;
  
  const primaryTextColor = 0; // RGB value for black: 0, 0, 0
  const secondaryTextColor = 128;

  const fontSize = 12;
  const fontSizeSmall = 9;
  const fontSizeTitle = 24;
  const fontSizeSubTitle = 18;

  let row = rowTop;

  // HEADER
  var img = new Image();
  img.src = LogoArpariNavy;
  let naturalLogoHeight = img.naturalHeight;
  let naturalLogoWidth = img.naturalWidth;
  const logoHeight = 30;
  const logoWidth = logoHeight * naturalLogoWidth / naturalLogoHeight;
  doc.addImage(img, "JPEG", marginPageLeft, rowTop - logoHeight / 2, logoWidth, logoHeight);

  doc.setFontSize(fontSizeSmall);
  doc.setTextColor(secondaryTextColor);
  doc.text("www.arpari.com", marginPageRight, row, { align: "right" });
  row = row + sectionRowDelta;

  // TITLE
  doc.setFontSize(fontSizeTitle);
  doc.setTextColor(primaryTextColor);
  doc.text(
      `${beneficiaryName} Domestic Transfer Details`,
      pageWidth / 2,
      row,
      { align: "center", maxWidth: pageWidth * .6 }
  );
  row = row + 2 * sectionRowDelta;

  // SUB TITLE
  doc.setFontSize(fontSize);
  doc.text(
      `Use these details to send domestic wires and ACH to ${beneficiaryName}'s Arpari account.`,
      marginPageLeft,
      row
  );
  row = row + sectionRowDelta;

  // BENEFICIARY
  doc.setFontSize(fontSizeSubTitle);
  doc.text("Beneficiary", marginPageLeft, row);
  row = row + intrasectionRowDelta;

  doc.setFontSize(fontSize);
  doc.setTextColor(secondaryTextColor);
  doc.text("Name", marginColumn1Left, row);
  doc.setTextColor(primaryTextColor);
  doc.text(beneficiaryName, marginColumn2Left, row);
  row = row + intrasectionRowDelta;

  doc.setTextColor(secondaryTextColor);
  doc.text("Address", marginColumn1Left, row);
  doc.setTextColor(primaryTextColor);
  doc.text(beneficiaryAddress, marginColumn2Left, row);
  row = row + sectionRowDelta;

  // ACCOUNT DETAILS
  doc.setFontSize(fontSizeSubTitle);
  doc.text("Account Details", marginPageLeft, row);
  row = row + intrasectionRowDelta;

  doc.setFontSize(fontSize);
  doc.setTextColor(secondaryTextColor);
  doc.text("Account Number", marginColumn1Left, row);
  doc.setTextColor(primaryTextColor);
  doc.text(accountNumber, marginColumn2Left, row);
  row = row + intrasectionRowDelta;

  doc.setTextColor(secondaryTextColor);
  doc.text("Routing Number", marginColumn1Left, row);
  doc.setTextColor(primaryTextColor);
  doc.text(routingNumber, marginColumn2Left, row);
  row = row + intrasectionRowDelta;

  doc.setTextColor(secondaryTextColor);
  doc.text("Account Type", marginColumn1Left, row);
  doc.setTextColor(primaryTextColor);
  doc.text(accountType, marginColumn2Left, row);
  row = row + sectionRowDelta;

  // BANK DETAILS
  doc.setFontSize(fontSizeSubTitle);
  doc.text("Bank Details", marginPageLeft, row);
  row = row + intrasectionRowDelta;

  doc.setFontSize(fontSize);
  doc.setTextColor(secondaryTextColor);
  doc.text("Name", marginColumn1Left, row);
  doc.setTextColor(primaryTextColor);
  doc.text(bankName, marginColumn2Left, row);
  row = row + intrasectionRowDelta;

  doc.setTextColor(secondaryTextColor);
  doc.text("Address", marginColumn1Left, row);
  doc.setTextColor(primaryTextColor);
  doc.text(bankAddress, marginColumn2Left, row);
  row = row + sectionRowDelta;

  // FOOTER
  doc.setFontSize(fontSizeSmall);
  doc.setTextColor(secondaryTextColor);
  doc.text(
      "Arpari is a financial technology company, not a bank. Banking services provided by Thread Bank, Member FDIC.",
      pageWidth / 2,
      rowBottom,
      { align: "center", maxWidth: pageWidth / 2 }
  );

  // save and export
  doc.save("ach-details.pdf");
}

export default generateAchDetailsPdf;
